import loadable from '@loadable/component';
export const manifest = {
  MainHeaderV3: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainHeaderV3";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainHeaderV3" */
          './main-header'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./main-header");
            }

            return eval('require.resolve')("./main-header");
          }

        }, {
          resolveComponent: m => m.MainHeaderV3
        })
      }
    }
  },
  'MainHeaderV3.Tabs': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainHeaderV3Tabs";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainHeaderV3Tabs" */
          './tabs'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./tabs");
            }

            return eval('require.resolve')("./tabs");
          }

        }, {
          resolveComponent: m => m.MainHeaderTabs
        })
      }
    }
  },
  'MainHeaderV3.Links': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainHeaderV3Links";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainHeaderV3Links" */
          './links'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./links");
            }

            return eval('require.resolve')("./links");
          }

        }, {
          resolveComponent: m => m.Links
        })
      }
    }
  }
};